import dayjs from 'dayjs'
import { pad } from 'lodash-es';

const $str = window.$str;

const chartColors = ['#4960FF', '#0CD5FF', '#2DFFAA', '#FFA441', '#944DFF', '#EE3CD3', '#FF532D', '#0DE24A']
const lineColor = "#3e4961"; // 图表splitLine的颜色
const textColor = "#8b93aa"; // 图表文字的颜色

const defaultMin = dayjs().format('YYYY-MM-DD 00:00:00');
const defaultMax = dayjs().format('YYYY-MM-DD 23:59:59');

/** 获取eCharts配置对象 */
export function getChartOption(chartData = [], packCount = 0, packIdx = 'all', filterType = 't_cell_max', start = defaultMin, end = defaultMax) {
  const { yMin, yMax } = getYaxisRange(chartData);

  const option = {
    color: chartColors,
    grid: [
      {
        top: 40,
        left: 50,
        right: 10,
        bottom: 80
      }
    ],
    xAxis: [
      {
        show: true,
        gridIndex: 0,
        nameLocation: 'end',
        nameTextStyle: {
          color: textColor
        },
        type: 'time',
        min: start,
        max: end,
        axisLabel: {
          color: textColor,
          formatter(value) {
            // return dayjs(value).format("YYYY-MM-DD HH:mm:ss").replace(/\s/, '\n');
            return dayjs(value).format("YYYY-MM-DD");
          },
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        }
      },
    ],
    yAxis: [
      {
        gridIndex: 0,
        type: 'value',
        name: $str.getKey('数据分析/温度(℃)'),
        nameLocation: 'end',
        nameGap: 20,
        nameTextStyle: {
          align: 'center',
          color: textColor,
          padding: [0, 0, 0, 35]
        },
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        min: yMin,
        max: yMax,
      },
    ],
    tooltip: createTooltip(),
    axisPointer: {
      link: { xAxisIndex: 'all' },
      label: {
        backgroundColor: '#777'
      }
    },
    legend: {
      show: true,
      top: 0, // 移动到顶部
      right: 10,
      icon: 'circle',
      itemWidth: 8,
      textStyle: {
        color: textColor
      }
    },
    series: createSeries(...arguments),
    dataZoom: [
      {
        height: 12,
        bottom: 20,
        textStyle: {
          color: '#8392A5'
        },
        handleIcon: 'path://M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        dataBackground: {
          areaStyle: {
            color: '#8392A5'
          },
          lineStyle: {
            opacity: 0.8,
            color: '#8392A5'
          }
        },
        brushSelect: true,
        start: 0,
        end: 100,
        xAxisIndex: [0, 1, 2, 3]
      },
      {
        type: 'inside',
        xAxisIndex: [0, 1, 2, 3]
      }
    ],
  }

  return option
}


function getYaxisRange(chartData) {
  const result = {
    yMin: 0,
    yMax: 100,
  }
  if (Array.isArray(chartData) && chartData.length > 0) {
    result.yMin = undefined;
    result.yMax = undefined;
  }

  return result;
}


function createSeries(chartData, packCount, packIdx, filterType) {
  const series = [];
  if (Array.isArray(chartData) && chartData.length > 0) {
    if (isNaN(Number(packIdx))) {
      // 渲染全部pack的数据
      for (let idxKey = 1; idxKey <= packCount; idxKey++) {
        const lineData = chartData.map(point => {
          const time = point.recordTime;
          const value = point[idxKey] ? point[idxKey][filterType] : '-';
          return [time, value];
        });
        const serieItem = {
          name: `${idxKey}#pack`,
          type: 'line',
          lineStyle: {
            width: 1,
          },
          data: lineData,
        }
        series.push(serieItem);
      }
    } else {
      // 渲染packIdx对应的pack数据
      const lineData = chartData.map(point => {
        const time = point.recordTime;
        const value = point[packIdx] ? point[packIdx][filterType] : '-';
        return [time, value];
      });
      const serieItem = {
        name: `${packIdx}#pack`,
        type: 'line',
        lineStyle: {
          width: 1,
        },
        data: lineData,
      }
      series.push(serieItem);
    }
  }
  return series;
}


/** 创建Tooltip的配置对象 */
function createTooltip(config = {}) {
  const timeFormatter = (value) => {
    // 格式化时间：如果是时间戳，转换为年月日时分秒；如果是时间字符串，直接使用
    let timeValue = value;
    if (typeof timeValue === 'number' || (typeof timeValue === 'string' && /^\d+$/.test(timeValue))) {
      // 判断是否是时间戳（毫秒或秒）
      const timestamp = Number(timeValue);
      const isMillisecond = timestamp > 946684800000; // 2000-01-01的时间戳（毫秒）
      timeValue = dayjs(isMillisecond ? timestamp : timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
    } else if (timeValue instanceof Date) {
      timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
    } else if (typeof timeValue === 'string') {
      // 如果已经是时间字符串，尝试格式化
      timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
    }
    return timeValue;
  };

  return {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    backgroundColor: 'rgba(255, 255, 255, 0.90)',
    borderWidth: 0,
    textStyle: {
      color: '#6A727C'
    },
    formatter(params) {
      let time = params[0].axisValue;
      time = timeFormatter(time);

      const str = (list) => {
        let t = '';
        for (let i = 0; i < list.length; i += 2) {
          const item1 = list[i];
          const item2 = list[i + 1];

          const originPrice1 = Array.isArray(item1.data) ? item1.data[1] : item1.data;
          const price1 = formatPriceValueForShow(originPrice1);

          const hasItem2 = !!item2;
          const item1Style = hasItem2
            ? 'display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5; flex: 1;'
            : 'display: flex; align-items: center; justify-content: flex-start; gap: 8px; line-height: 1.5;';
          const item1InnerStyle = hasItem2
            ? 'display: flex; align-items: center; gap: 6px; flex: 1;'
            : 'display: flex; align-items: center; gap: 6px;';

          t += /* html */`
            <div style="display: flex; gap: 16px; margin-bottom: 8px;">
              <div class="chart-tooltip__series" style="${item1Style}">
                <div style="${item1InnerStyle}">
                  <div class="chart-tooltip__point" style="background: ${item1.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                  <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${item1.seriesName}</div>
                </div>
                <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${price1 ?? '--'}</div>
              </div>`;

          if (item2) {
            const originPrice2 = Array.isArray(item2.data) ? item2.data[1] : item2.data;
            const price2 = formatPriceValueForShow(originPrice2);
            t += /* html */`
              <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5; flex: 1;">
                <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                  <div class="chart-tooltip__point" style="background: ${item2.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                  <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${item2.seriesName}</div>
                </div>
                <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${price2 ?? '--'}</div>
              </div>
            </div>`;
          } else {
            t += `</div>`;
          }
        }
        return t;
      };

      return /* html */`
        <div class="chart-tooltip__time" style="margin-bottom: 12px;">${time}</div>
        <div class="chart-tooltip__items-container">${str(params)}</div>
        `;
    }
  }
}

/** 格式化：价格展示时-只保留两位小数 */
function formatPriceValueForShow(price) {
  if (typeof (price) === 'number' && !isNaN(price)) {
    return (+price).toFixed(2);
  } else {
    return price
  }
}




